import * as _ from "lodash";

type NodeIdToGuid = { [key: number]: string };
type GuidToNodeId = { [key: string]: number };
type IdMapping = {
    nodeIdToGuid: NodeIdToGuid;
    guidToNodeId: GuidToNodeId;
}


/**
 * Mapping from nodeId to GUID (original map) and vice-versa.
 * Also Forge model id to SD guid.
 */
export class IdMap {

    // Model id mapping to both the GUID<->nodeid maps.
    private nodeIdMap: { [key: string]: IdMapping } = {};
    // Model GUID to model id
    private modelGuidMap: { [key: number]: string } = {};
    // Model id to model GUID
    private modelIdMap: { [key: string]: number } = {};

    addMap(modelId: number, modelGuid: string, map: { [key: string]: string }) {
        const nodeIdToGuid: NodeIdToGuid = {};
        if (map != null) {
            for (let key in map) {
                nodeIdToGuid[Number(key)] = map[key];
            }
        }
        const guidToNodeId: GuidToNodeId = {};
        if (map != null) {
            for (let key in map) {
                const value = map[key];
                guidToNodeId[value] = Number(key);
            }
        }
        this.nodeIdMap[modelGuid] = { nodeIdToGuid: nodeIdToGuid, guidToNodeId: guidToNodeId };
        this.modelIdMap[modelGuid] = modelId;
        this.modelGuidMap[modelId] = modelGuid;
    }

    guid(modelGuid, nodeId): string {
        if (modelGuid === null) {
            return _.values(this.nodeIdMap)[0].nodeIdToGuid[nodeId];
        }
        return this.nodeIdMap[modelGuid].nodeIdToGuid[nodeId];
    }

    nodeId(modelGuid, guid): number {
        if (modelGuid === null) {
            return _.values(this.nodeIdMap)[0].guidToNodeId[guid];
        }
        return this.nodeIdMap[modelGuid].guidToNodeId[guid];
    }

    guids(modelGuid, nodeIds): string[] {
        return nodeIds.map(nodeId => this.guid(modelGuid, nodeId)).filter(v => v != null);
    }

    nodeIds(modelGuid, guids): number[] {
        return guids.map(guid => this.nodeId(modelGuid, guid)).filter(v => v != null);
    }

    modelGuid(modelId: number): string {
        return this.modelGuidMap[modelId];
    }

    modelId(modelGuid: string): number {
        return this.modelIdMap[modelGuid];
    }

    getModelById(id: number, viewer: Autodesk.Viewing.Viewer3D): Autodesk.Viewing.Model {
        for (let m of viewer.getVisibleModels()) {
            if (m.id === id) {
                return m;
            }
        }
        return null;
    }

    getModelByGuid(guid: string, viewer: Autodesk.Viewing.Viewer3D): Autodesk.Viewing.Model {
        return this.getModelById(guid != null ? this.modelId(guid) : 1, viewer);
    }

    getAggregateFromShareSelections(ids: string[], viewer: Autodesk.Viewing.Viewer3D) {
        const aggregateMap =_.reduce(ids,
            (acc, id) => {
                const [modelGuid, nodeId] = _.includes(id, "/") ? id.split("/") : [null, id];
                const modelId = modelGuid != null ? this.modelId(modelGuid) : 1;
                const modelSelection = acc[modelId];
                if (modelSelection != null) {
                    modelSelection.ids = [...modelSelection.ids, Number(nodeId)];
                    modelSelection.selection = [...modelSelection.selection, Number(nodeId)];
                } else {
                    acc[modelId] = { model: this.getModelByGuid(modelGuid, viewer), ids: [Number(nodeId)], selection: [Number(nodeId)], selectionType: Autodesk.Viewing.SelectionMode.REGULAR }
                }
                return acc;
            },
            {});
        return _.values(aggregateMap);
    }

    isEmpty() {
        return _.isEmpty(this.nodeIdMap);
    }
}